"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerEventType = void 0;
exports.TrackerEventType = {
    VIEW: "VIEW",
    PLAY: "PLAY",
    SIGNUP: "SIGNUP",
};
